import React from 'react';
import { RaisedButton } from 'material-ui';
import config from 'cfg';

const getWindowName = service => `Connect your ${service} account to WDP`;

const SMPG_ORIGIN = config.apis.smpg;

export default class SMLink extends React.PureComponent {
    componentDidMount() {
        addEventListener('message', this.onMessageReceived, false);
    }

    onMessageReceived = message => {
        const { onChange } = this.props;
        if (message.origin === SMPG_ORIGIN && onChange) {
            onChange(message);
        }
    };

    onButtonClick = () => {
        const { address, title } = this.props;
        const windowName = getWindowName(title);
        window.open(address, windowName, 'height=500,width=700');
    };

    render() {
        const { title, style, type } = this.props;
        
        return (
            <RaisedButton
                primary
                labelColor={'white'}
                label={title}
                style={style}
                onClick={this.onButtonClick}
            />
        );
    }
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/SMLink/SMLink.js
 **/